import { Injectable } from '@angular/core';
import { AvisInitialService } from '../avisInitial/avis-initial.service';
import { DescriptionService } from '../description/description.service';
import { InfosRectifService } from '../infos-rectif/infos-rectif.service';

@Injectable({
  providedIn: 'root',
})
export class RectificatifService {
  constructor(public avisInitialService: AvisInitialService, public infosRectifService: InfosRectifService,
    public descriptionService: DescriptionService ) {}
}
